export default "__VITE_ASSET__7e496207__"